module.exports = __webpack_public_path__ + "img/report-2-eng.1ddfc30b.png";